import { FormControl, FormLabel, Switch } from '@chakra-ui/react'

import { useIsAdmin, useTeam, useUpdateTeam } from '@/react-query/team'

export const TeamVisibility = () => {
  const team = useTeam().data
  const updateTeam = useUpdateTeam()

  const isAdmin = useIsAdmin()
  if (!isAdmin) {
    return null
  }

  return (
    <FormControl display={'flex'} alignItems={'center'}>
      <Switch
        id="enable-team-visibility"
        onChange={(event) => {
          event.preventDefault()
          const value = event.target.checked
          updateTeam.mutate({ isVisibilityEnabled: value })
        }}
        checked={team?.isVisibilityEnabled || false}
        defaultChecked={team?.isVisibilityEnabled || false}
        size={'lg'}
        variant={'brand-black'}
      />
      <FormLabel htmlFor="enable-team-visibility" mb="0" ml={'4'}>
        All interviews are visible for everyone
      </FormLabel>
    </FormControl>
  )
}
